import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-app-status';
const API_DETAIL = (id: number) => `/p-crm-app-status/${id}`;

export interface AppStatus {
  id: number;
  as_descr?: string;
  as_color?: string;
}

export const useAppStatuss = (searchParams?: string) => {
  const params = new URLSearchParams({ manage: '1' });
  if (searchParams) params.set('searchParams', searchParams);
  const queryString = `?${params.toString()}`;
  const { data, error, isLoading, mutate } = useSWR<AppStatus[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    appStatuss: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useAppStatus = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<AppStatus>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    appStatus: data,
    isLoading,
    isError: error,
    mutate,
  };
};
